module.exports = __webpack_public_path__ + "img/scene-industry.881a1f0f.jpg";